import Lottie from 'lottie-react'
import { TypographyComponent } from 'src/components/Typography'
import styled, { css } from 'styled-components'

export const MainContainer = styled('div')(
  ({ theme }) => css`
    min-height: 100vh;
    display: flex;

    @media (max-width: ${theme.screen.medium}) {
      flex-direction: column;
    }
  `
)

export const LeftContainer = styled('div')(
  ({ theme }) => css`
    width: 58vw;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-start;
    background-color: ${theme.colors.base.brandBlue};
    padding-top: ${theme.layout.padding.big};
    padding-right: ${theme.layout.padding.base * 9}rem;
    padding-left: ${theme.layout.padding.big};

    @media (max-width: ${theme.screen.medium}) {
      width: 100%;
      padding-right: ${theme.layout.padding.big};
      padding-bottom: ${theme.layout.padding.big};
    }
  `
)

export const RightContainer = styled('div')(
  ({ theme }) => css`
    width: 42vw;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    @media (max-width: ${theme.screen.medium}) {
      width: 100%;
      align-items: center;
    }
  `
)

export const HeaderSection = styled('div')(
  ({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: ${theme.layout.gap.big};
    width: 100%;
  `
)

export const Mosaic = styled('img')(
  ({ theme }) => css`
    opacity: 0.2;
    width: 24rem;
    object-fit: contain;

    @media (max-width: ${theme.screen.medium}) {
      display: none;
    }
  `
)

export const Title = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-style: normal;
      font-weight: 700;
      font-size: ${theme.typograph.fontsize.base * 16}rem;
      line-height: ${theme.layout.lineHeight.base * 5}rem;
      color: ${theme.colors.base.white};
      text-align: right;
    }
  `
)

export const Description = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-style: normal;
      font-weight: 400;
      font-size: ${theme.typograph.fontsize.h6};
      line-height: ${theme.layout.lineHeight.base * 5}rem;
      color: ${theme.colors.base.white};
      text-align: right;
      white-space: pre-line;
      padding-top: ${theme.layout.padding.base * 5}rem;
    }
  `
)

export const LottieSection = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${theme.layout.gap.base * 6}rem;

    @media (max-width: ${theme.screen.medium}) {
      padding-top: ${theme.layout.padding.big};
      padding-bottom: ${theme.layout.padding.big};
      gap: ${theme.layout.gap.big};
    }
  `
)

export const LottieAnimation = styled(Lottie)(
  ({ theme }) => css`
    max-width: 70rem;
    min-width: 17.5rem;

    @media (max-width: ${theme.screen.medium}) {
      max-width: 20rem;
      min-width: 10rem;
    }
  `
)
